import React from 'react'

import Card from './card'
import * as cardStyles from './card.module.scss'

type CardsProps = {
  items: readonly Card[]
  numberTotal: number
}

const Cards: React.FC<CardsProps> = ({ items, numberTotal }) => {
  return (
    <>
      <div className="container">
        <div className={cardStyles.results}>
          <div className={cardStyles.numberTotal}>{numberTotal} results</div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          {items.map((listItem) => (
            <div className="col-lg-4 col-md-6 mb-5 mt-0" key={listItem.id}>
              <Card item={listItem} />
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export default Cards
